import React, { useEffect, useRef } from "react";
import { useTheme } from "../ThemeContext";

export default function CursorGlow() {
  const { isDark, isDev } = useTheme();
  const glowRef = useRef(null);

  useEffect(() => {
    let animationFrame;

    const handleMouseMove = (event) => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(() => {
        if (!glowRef.current) return;
        glowRef.current.style.transform = `translate3d(${event.clientX - 400}px, ${
          event.clientY - 400
        }px, 0)`;
      });
    };

    window.addEventListener("mousemove", handleMouseMove, { passive: true });

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.cancelAnimationFrame(animationFrame);
    };
  }, []);

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden transition-opacity duration-1000"
      style={{ opacity: isDark ? 0.35 : 0.15 }}
    >
      <div
        ref={glowRef}
        className="absolute h-[800px] w-[800px] rounded-full blur-[120px] transition-transform duration-[1500ms] ease-out mix-blend-screen"
        style={{
          background: isDev
            ? "radial-gradient(circle, rgba(16,185,129,0.5) 0%, rgba(5,11,11,0) 70%)"
            : isDark
              ? "radial-gradient(circle, rgba(220,38,38,0.5) 0%, rgba(30,30,40,0) 70%)"
              : "radial-gradient(circle, rgba(220,38,38,0.6) 0%, rgba(255,255,255,0) 70%)",
          transform: "translate3d(-1000px, -1000px, 0)",
        }}
      />
    </div>
  );
}
